import { Button, Divider, Flex, IconClipboard, IconLinkThin, Text } from "@powerledger/ui-component-lib";

import { AccountType } from "@/app/types/generated/graphql";

export const getIcon = (selected = false, iconFor = AccountType.Registry) =>
  iconFor === AccountType.Registry ? (
    <IconLinkThin
      size={60}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        svg: {
          width: 50,
          height: 50,
          path: {
            stroke: "primary.500",
          },
        },
      }}
    />
  ) : (
    <IconClipboard
      size={60}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        svg: {
          width: 50,
          height: 50,
          path: {
            stroke: "transparent !important",
            fill: "primary.500",
          },
        },
      }}
    />
  );

export const AccountTypeSelectCard = ({
  text,
  getIcon,
  onClick,
  selected,
  details,
  testID,
}: {
  onClick: () => void;
  text: string;
  getIcon: (selected: boolean) => React.ReactElement;
  selected: boolean;
  details?: React.ReactElement;
  testID?: string;
}) => (
  <Button
    variant="outlined"
    sx={{
      borderRadius: 4,
      boxShadow: `0 0 5px var(--theme-ui-colors-shadow)`,
      width: 300,
      flexDirection: "column",
      background: selected ? "primary.25" : "pageBackground",
      border: selected ? "2px solid var(--theme-ui-colors-primary-500)" : "1px solid var(--theme-ui-colors-textDark)",
      "&:hover, &:focus": { background: "primary.25" },
      justifyContent: "center",
      alignItems: "center",
      textAlign: "left",
      cursor: "pointer",
    }}
    onClick={onClick}
    data-testid={testID}
  >
    <Flex
      sx={{
        width: "100%",
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "center",
        gap: 2,
      }}
    >
      {getIcon(selected)}
      <Text
        sx={{
          fontSize: 1,
          color: selected ? "primary.500" : "textDarker",
          fontWeight: 600,
          fontFamily: "MintGroteskV08",
        }}
      >
        {text}
      </Text>
    </Flex>
    {details && (
      <>
        <Divider sx={{ color: "shadow", width: "100%" }} />
        <Flex
          sx={{
            justifyContent: "flex-start",
            mt: 3,
          }}
        >
          {details}
        </Flex>
      </>
    )}
  </Button>
);
